angular.module('lead')
    .service('LeadOfferService', function (modals, LeadActivityService) {
        this.sendEmail = (lead) => {
            return modals.open('app/lead/offer/send-email.html', 'LeadOfferSendEmailController', lead, {size: 'lg'}, "$ctrl")
                .then(() => LeadActivityService.addForLeadId(lead.id))
        }
    })

